import styled, { css } from 'styled-components';

import { colors, layout, colorUtils } from '@prisjakt/ui-base';
import { Floater } from '@regular_ui/lib/components/floater';

import ToggleIcon from '../../../icons/toggle-sidebar';
import { EmoticonSmiling as EmoticonSmilingBase } from '../../../../../../components/user-sentiment/components/icons';

const padding = layout.spacing.xSmall;
const menuWidth = layout.sidebarMenuWidth.desktop;

export const SidebarMenu = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  width: ${menuWidth.rem};
  background-color: ${colors.semiWhite};
  padding: ${padding} 0;
  z-index: 99;
`;

export const TopBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > * {
    margin-top: ${padding};
    margin-bottom: ${padding};
  }
`;

export const BottomBar = styled.div`
  position: relative;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${padding};
  padding-top: ${padding};

  > * {
    margin-top: ${padding};
    margin-bottom: ${padding};
  }
`;

type MenuButtonProps = {
  active?: boolean;
  hoverEffect?: 'background' | 'color';
  hidden?: boolean;
};

export const MenuButton = styled.button<MenuButtonProps>(
  props => css`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    margin-left: auto;
    margin-right: auto;
    transition: background 200ms ease, color 200ms ease, visibility 0s ease 0s,
      opacity 200ms;
    background: transparent;
    color: ${props.theme.icons.tertiary};
    visibility: visible;
    opacity: 1;

    ${props.active &&
      css`
        color: ${props.theme.icons.callToAction};
      `}

    rect,
    path {
      fill: ${props.active ? props.theme.icons.callToAction : 'currentColor'};
    }

    ${props.hidden &&
      css`
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s ease 200ms, opacity 200ms;
      `}

    &:hover,
    &.focus-visible {
      ${props.hoverEffect === 'background' &&
        css`
          background-color: ${props.active
            ? colorUtils.hexToRgbaString(props.theme.icons.callToAction, 0.2)
            : colorUtils.hexToRgbaString(props.theme.icons.tertiary, 0.2)};
        `};

      ${props.hoverEffect === 'color' &&
        css`
          color: ${props.theme.icons.callToAction};
        `};
    }
  `
);

MenuButton.defaultProps = {
  hoverEffect: 'background',
};

export const Divider = styled.div`
  pointer-events: none;
  background: ${p => p.theme.lines.primary};
  height: 1px;
  width: 75%;
`;

type ToggleSidebarIconProps = {
  open: boolean;
};
export const ToggleSidebarIcon = styled(ToggleIcon)<ToggleSidebarIconProps>`
  transition: transform 200ms ease;
  transform: ${p => (p.open ? 'rotate(180deg)' : 'none')};
`;

export const EmoticonSmiling = styled(EmoticonSmilingBase)`
  path {
    fill: none;
  }

  g {
    stroke: currentColor;
  }
`;

export const UserSentimentWrapper = styled(Floater)`
  width: 300px;
  height: 160px;
  background: ${colors.white};
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
`;
